<template>
  <div v-loading='loading'>
    <el-button @click="drawerOrder=true" type="primary" size="small" class="lookButton"><i class="el-icon-view"></i> 红字发票订单</el-button>
    <div class="item">
      <label>客户名称</label>
      <div class="inputDiv">{{dataInfo.customer_name}}</div>
    </div>
    <div class="item">
      <label>申请日期</label>
      <div class="inputDiv">{{add_date}}</div>
    </div>
    <div class="item">
      <label>申请人</label>
      <div class="inputDiv">{{userInfo.real_name}}</div>
    </div>
    <div class="item">
      <label>开票金额</label>
      <div class="inputDiv">{{dataInfo.amount}}</div>
    </div>
    <div class="item">
      <label><em class="stars">*</em>发票类型</label>
      <el-select style="width:240px" v-model="uploadFileData.invoice_type" size='mini' filterable placeholder="请选择">
        <el-option v-for="(item,index) in invoiceTypeList" :key="index" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="item">
      <label><em class="stars">*</em>发票服务类型</label>
      <div class="inputDiv" :style="!customerData.service_type?'color:red':''">{{customerData.service_type?customerData.service_type:'发票服务类型不存在，请先进行配置！'}}</div>
    </div>
    <div class="item">
      <label>备注</label>
      <el-input class="input" v-model="uploadFileData.invoice_note" size='mini' placeholder="请输入备注"></el-input>
    </div>
    <div class="item">
      <label>收件人</label>
      <el-input class="input" v-model="uploadFileData.consignee" size='mini' placeholder="请输入收件人"></el-input>
    </div>
    <div class="item">
      <label>联系人</label>
      <el-input class="input" v-model="uploadFileData.contacts" size='mini' placeholder="请输入联系人"></el-input>
    </div>
    <div class="item">
      <label>联系方式</label>
      <el-input class="input" v-model="uploadFileData.contact_number" size='mini' placeholder="请输入联系方式"></el-input>
    </div>
    <div class="item">
      <label>邮寄地址</label>
      <el-input class="input" v-model="uploadFileData.mail_address" size='mini' placeholder="请输入邮寄地址"></el-input>
    </div>
    <div class="item">
      <label>开票说明</label>
      <el-input class="input" v-model="uploadFileData.note" size='mini' placeholder="请输入开票说明"></el-input>
    </div>
    <div class="line"></div>
    <div class="item">
      <label>名称</label>
      <div class="inputDiv">{{customerData.customer_name}}</div>
    </div>
    <div class="item">
      <label>税号</label>
      <div class="inputDiv">{{customerData.party_a_ein}}</div>
    </div>
    <div class="item">
      <label style="vertical-align: top;">地址/电话</label>
      <div class="inputDiv">{{customerData.party_a_address}}</div>
    </div>
    <div class="item">
      <label style="vertical-align: top;">银行/账号</label>
      <div class="inputDiv">{{customerData.party_a_account}}</div>
    </div>
    <div class="item">
      <add-file @file='(val)=>{uploadFileData.files=val}' :fileOtherList='[]' :uploadOtherFile='[]'></add-file>
    </div>
    <div slot="footer" style="text-align: center;margin-top:40px">
      <el-button type="primary" size='small' @click="submitUpload">提 交</el-button>
      <el-button size='small' @click="closeToast">取 消</el-button>
    </div>
    <el-drawer title="红字发票订单" :visible.sync="drawerOrder" append-to-body size="1100px">
      <div style="margin:0 20px">
        <el-table :data="dataInfo&&dataInfo.list" height="calc(100vh - 107px)" :header-cell-style="{background:'#f5f7fa'}">
          <el-table-column min-width="60" align="center" property="task_id" label="任务ID"></el-table-column>
          <el-table-column min-width="100" align="center" property="month" label="月份"></el-table-column>
          <el-table-column min-width="100" align="center" property="order_original_month" label="实际消耗月份"></el-table-column>
          <el-table-column min-width="100" align="center" property="project_name" label="项目名称"></el-table-column>
          <el-table-column min-width="100" align="center" property="customer_name" label="客户名称"></el-table-column>
          <el-table-column min-width="100" align="center" property="company" label="签约公司"></el-table-column>
          <el-table-column min-width="100" align="center" property="internet_celebrity_name" label="达人名称"></el-table-column>
          <el-table-column min-width="100" align="center" property="internet_celebrity_id" label="达人ID"></el-table-column>
          <el-table-column min-width="100" align="center" property="launch_start_date" label="上线时间"></el-table-column>
          <el-table-column min-width="100" align="center" property="media_name" label="媒体名称"></el-table-column>
          <el-table-column min-width="100" align="center" property="red_invoice_amount" label="申请红票金额"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
export default {
  components: { addFile },
  props: ['filename'],
  data () {
    return {
      invoiceType: '',
      invoiceTypeList: [{ name: '增值税专用发票', id: 1 }, { name: '增值税普通发票', id: 2 }],
      invoiceServiceType: '',
      note: '',
      dutyParagraph: '',
      phone: '',
      bank: '',
      add_date: '',//申请日期 当前日期
      userInfo: {},
      uploadFileData: {
        filename: this.filename,
        invoice_type: '',
        service_type: '',
        invoice_note: '',
        consignee: '',
        contacts: '',
        contact_number: '',
        mail_address: '',
        note: '',
        files: []
      },
      loading: false,
      fileList: [],
      dataInfo: {},
      customerData: {},
      drawerOrder: false
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    //当前日期
    var date = new Date();
    this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
  },
  mounted () {
    this.redApplyOrders()
  },
  methods: {
    redApplyOrders () {//获取红字发票订单
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.redApplyOrders, {
        params: {
          filename: this.filename
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.customerListEvent(res.rst.customer_name)
        } else {
          this.loading = false;
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    closeToast () {
      this.$emit('closeToast')
    },
    submitUpload () {//上传
      if (this.uploadFileData.invoice_type == '') {
        this.$message({
          message: '请选择发票类型',
          type: 'warning'
        })
        return
      }
      if (!this.uploadFileData.service_type || this.uploadFileData.service_type == '') {
        this.$message({
          message: '发票服务类型不存在，请先进行配置！',
          type: 'warning'
        })
        return
      }
      if (this.uploadFileData.files.length <= 0) {
        this.$message({
          message: '请上传附件',
          type: 'success'
        })
        return;
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.redApplyConfirm, this.uploadFileData).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$emit('updateList')
          this.$message({
            message: '上传成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$message({
          message: '上传失败',
          type: 'fail'
        })
        this.loading = false
      })
    },
    changeUpload (file, fileList) {
      this.fileList = fileList;
    },
    removeFile (file) {
      this.fileList = this.fileList.filter((v) => {
        return v.name + v.uid != file.name + file.uid
      })
    },
    customerListEvent (customer_name) {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 20,
          customer_name: customer_name
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.customerData = res.rst.data && res.rst.data.length > 0 ? res.rst.data[0] : {};
          this.uploadFileData.service_type = this.customerData.service_type ? this.customerData.service_type : ''
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.item {
  margin-bottom: 20px;
  margin-left: 60px;
  label {
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
    width: 100px;
    .stars {
      color: red;
    }
  }
  .inputDiv {
    display: inline-block;
    color: #5e5f6b;
    font-size: 14px;
    line-height: 20px;
  }
  .input {
    width: 60%;
    display: inline-block;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #e6e6ef;
  margin-bottom: 20px;
}
.uploadFile {
  display: inline-block;
}
.lookButton {
  position: absolute;
  right: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/redInvoices/InvoiceFilling.vue